import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

import { map } from "rxjs";
import { environment } from "../../../../environments/environment";
import { ApiErrorHandlerService } from "../../utils/api-error-handler/api-error-handler.service";
import { Core } from "../../../models/api/tenant";

@Injectable({
  providedIn: "root",
})
export class BotevoCoresService {
  private http = inject(HttpClient);
  private apiErrorHandler = inject(ApiErrorHandlerService);

  /**
   * Fetches all cores.
   * @returns {Observable<Core[]>} An observable emitting an array of cores.
   */
  public getCores() {
    return this.http
      .get<Core[]>(environment.baseUrl + `/core/allCores`, {
        observe: "response",
      })
      .pipe(
        this.apiErrorHandler.handle("core"),
        map((res) => res.body)
      );
  }

  /**
   * Links a core to a tenant.
   * @param {string} coreId - The ID of the core.
   * @param {string | undefined} tenantId - The ID of the tenant.
   * @returns {Observable<HttpResponse<any>>} The HTTP response observable.
   */
  public linkCore(coreId: string, tenantId: string | undefined) {
    return this.http
      .post(
        environment.baseUrl + `/core/createLinkCore/${coreId}`,
        { tenant: { id: tenantId?.toString() } },
        { observe: "response" }
      )
      .pipe(this.apiErrorHandler.handle("core"));
  }

  /**
   * Removes a core link from a tenant.
   * @param {string | undefined} coreId - The ID of the core.
   * @param {string | undefined} tenantId - The ID of the tenant.
   * @returns {Observable<HttpResponse<any>>} The HTTP response observable.
   */
  public removeLinkCore(coreId: string | undefined, tenantId: string | undefined) {
    return this.http
      .post(
        environment.baseUrl + `/core/removeLinkCore/${coreId}`,
        { tenant: { id: tenantId?.toString() } },
        { observe: "response" }
      )
      .pipe(this.apiErrorHandler.handle("core"));
  }
}
